import { formatMetricValue } from "./helpers/formatMetricValue";
import { MetricType } from "./Metrics.types";

export class HydratedValue {
    readonly number: number | null;
    readonly type: MetricType;

    constructor(number: number | null, type: MetricType) {
        this.number = number;
        this.type = type;
    }

    isNull(): boolean {
        return this.number === null;
    }

    hasValue(): boolean {
        return this.number !== null;
    }

    getValue(): number | null {
        return this.number;
    }

    getValueOrDefault(defaultValue: number): number {
        return this.number ?? defaultValue;
    }

    getValueOrZero(): number {
        return this.number ?? 0;
    }

    getFormattedValue(): string {
        if (this.isNull()) return "-";
        return formatMetricValue(this.number, this.type);
    }
}
